<template>

    <div class="box sidebar sidebar--padding sidebar--padding">
        <div class="collapsible" v-if="collapseActive">
            <div class="sidebar__title h3"
                :class="{'sidebar__title--no-margin': collapsed}"
            >
                <a href="#"
                   class="collapsible__trigger"
                   :class="{'collapsible__trigger--active': !collapsed}"
                   @click.prevent="collapsed = !collapsed">
                      <i class="icon-filter"></i>  Filter resultaten
                </a>
            </div>
            <div v-if="!collapsed">
                <Searchable
                        @heightChanged="childHeightChanged"
                />
                <Filters
                    @heightChanged="childHeightChanged"
                />
                <FloatingButton
                    label="Toon resultaten"
                    :tolerance="150"
                    @click="floatingButtonClicked"
                />
            </div>
        </div>
        <div v-else>
            <div class="h3 sidebar__title">
                <i class="icon-filter"></i> Filter resultaten
            </div>
            <Searchable/>
            <Filters
            />
        </div>
    </div>
</template>
<script>

import {computed, onMounted, ref, watchEffect} from 'vue';
import Filters from '../Filters/Filters'
import Searchable from '../Searchable/Searchable'
import FloatingButton from '../Utils/FloatingButton'
import {useStore} from "vuex";

export default {
    name: 'SideView',
    components: {Filters, Searchable, FloatingButton},
    data() {
        return {
            collapsed: true,
        }
    },
    methods: {
        floatingButtonClicked() {
            this.collapsed = true;
            this.$emit('scrollToMainView');
        }
    },
    setup() {
        const store = useStore()
        const windowInnerWidth = ref(window.innerWidth);
        const fetchState = computed(() => store.state.fetchState)
        const collapseActive = computed(() => {
            return windowInnerWidth.value <= 992;
        });

        onMounted(() => {
            window.addEventListener('resize', () => windowInnerWidth.value = window.innerWidth);
        });

        return {
            collapseActive,
            fetchState
        };
    }
}
</script>